import { render } from "./ConsultarDetalle.vue?vue&type=template&id=77b58e38"
import script from "./ConsultarDetalle.vue?vue&type=script&lang=js"
export * from "./ConsultarDetalle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__